import { render, staticRenderFns } from "./LayoutDefault.vue?vue&type=template&id=fbf7fdd2&scoped=true"
import script from "./LayoutDefault.vue?vue&type=script&lang=js"
export * from "./LayoutDefault.vue?vue&type=script&lang=js"
import style0 from "./LayoutDefault.vue?vue&type=style&index=0&id=fbf7fdd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf7fdd2",
  null
  
)

export default component.exports